import { TranslationKey } from "../../../../shared/i18n/i18n";
import { FieldVisibility, InternalFieldVisibilityIcon, PublicFieldVisibilityIcon } from "../../common/FieldVisibilityIcon";

type AdminDetailLabelProps = {
  label: string;
  t: (key: TranslationKey) => string;
  visibility: FieldVisibility;
};

export const AdminDetailLabel = ({ label, t, visibility }: AdminDetailLabelProps) => {
  const tooltipKey = visibility === "public"
    ? "admin.detail.visibility.public"
    : visibility === "internal"
      ? "admin.detail.visibility.internal"
      : null;

  return (
    <span className="admin-detail-label">
      <span className="admin-detail-label-text">{label}</span>
      {visibility === "public" && tooltipKey ? (
        <PublicFieldVisibilityIcon label={t(tooltipKey)} />
      ) : visibility === "internal" && tooltipKey ? (
        <InternalFieldVisibilityIcon label={t(tooltipKey)} />
      ) : null}
    </span>
  );
};
